import React from 'react';

import { List } from '../../Generic';
import Correct from './Correct';
export default function PracticalWork() {
  const styles = {
    heading: {
      color: 'white'
    },
    img: {
      width: '30%',
      height: '30%'
    },
    imgBig: {
      width: '40%',
      height: '40%',
      marginBottom: '20%'
    }
  };
  return (
    <>
      <section data-background-color="CadetBlue">
        <h1 style={styles.heading}>TP</h1>
      </section>
      <section>
        <h2>Consignes</h2>
        <List
          list={["Rapport à alimenter pour l'avancement (markdown ou autre)"]}
        />
      </section>

      <section>
        <h1>TP</h1>
        <a href="https://git.kaz.bzh/francois.lesueur/R3.06/src/branch/master/td6-archi.md">
          https://git.kaz.bzh/francois.lesueur/R3.06/src/branch/master/td6-archi.md
        </a>
      </section>

      <section data-background-color="CadetBlue">
        <h1 style={styles.heading}>Correction</h1>
      </section>
      <Correct />
    </>
  );
}
